import { CaretLeft } from "@phosphor-icons/react";
import { useLocation, useNavigate } from "react-router-dom";
import SavedAddresses from "../../../components/SavedAddresses";
import { leaveSetupTask } from "../../../utils/setupTaskReturn";

/** Compliance-settings chrome around the shared AddressForm. */
const HomeAddress = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as { fromSetup?: boolean; returnTo?: string } | null;
  const fromSetup = state?.fromSetup;

  return (
    <div className="bg-gray-50 p-5 md:p-10 flex items-center justify-center">
      <div className="flex flex-col gap-8 max-w-4xl w-full">
        <div className="flex gap-2 flex-col">
          <div className="flex items-center gap-2">
            <div
              onClick={() => navigate(-1)}
              className="p-2 text-center text-deepBlue border px-6 rounded-xl font-medium flex gap-2 items-center border-gray-300 cursor-pointer hover:bg-gray-100"
            >
              <CaretLeft weight="bold" />
              <span>Back</span>
            </div>
          </div>
          <div className="text-2xl font-bold">Home Address</div>
          <div>
            <span className="text-sm text-gray-500">
              Add your residential address. Choose a suggestion when available,
              or enter the address manually.
            </span>
          </div>
        </div>

        <div className="bg-white rounded-lg w-full shadow-sm flex-col gap-5 flex p-5">
          <SavedAddresses
            onSaved={() =>
              leaveSetupTask(navigate, state, fromSetup ? "/home" : "/home/settings/compliance")
            }
          />
        </div>
      </div>
    </div>
  );
};

export default HomeAddress;
